<div class="queue-filter-field extension-multi-select" [matTooltip]="'Select Queues'">
   <lcs-advanced-multi-select
      [headerText]="'Queues'"
      [triggerConfig]="queueFilterTriggerConfig()"
      [datasources]="[queueFilterDataSource()]"
      [hasRestoreDefaults]="false"
      [isSortable]="false"
      (openDialog)="onQueueFilterOpen()"
      (save)="onQueueFilterSave($event)"
      (search)="onQueueFilterSearch($event)"
      (selectedItemsChange)="onQueueFilterSelectedItemsChange($event)"
      (drop)="onQueueFilterDrop($event)"
      (close)="onQueueFilterClose()"
   >
      <ng-template let-context advancedMultiSelectItemListDisplay>
         @if (context.position === 'right') {
         <div
            class="queue-history-queue-filter-selected-list"
            cdkDropList
            cdkDropListLockAxis="y"
            cdkDropListOrientation="vertical"
            [cdkDropListData]="context.items"
            [cdkDropListDisabled]="context.position !== 'right' || !isQueueFilterSortable"
            (cdkDropListDropped)="onQueueFilterSelectedItemsDrop($event, context)"
         >
            @for (item of context.items; track item.extensionId) {
            <div
               class="queue-history-queue-filter-selected-item"
               cdkDrag
               cdkDragLockAxis="y"
               [cdkDragData]="item"
               [cdkDragDisabled]="!isQueueFilterSortable"
            >
               @if (isQueueFilterSortable) {
               <mat-icon class="queue-history-queue-filter-drag-handle" cdkDragHandle>drag_indicator</mat-icon>
               }
               <span class="queue-history-queue-filter-selected-label">{{ getQueueOptionLabel(item) }}</span>
               <mat-icon
                  class="queue-history-queue-filter-remove"
                  (click)="onQueueFilterSelectedItemRemove($event, context, item)"
               >
                  close
               </mat-icon>
               <ng-template cdkDragPlaceholder>
                  <div class="queue-history-queue-filter-selected-item-placeholder"></div>
               </ng-template>
            </div>
            }
         </div>
         } @if (context.position !== 'right') { @for (item of context.items; track item.extensionId) {
         <div>
            <lcs-advanced-multi-select-item
               [context]="context"
               [item]="item"
               [selected]="isQueueFilterItemSelected(context.state.selectedItems(), item)"
            >
               {{ getQueueOptionLabel(item) }}
            </lcs-advanced-multi-select-item>
         </div>
         } }
      </ng-template>
   </lcs-advanced-multi-select>
</div>
